import { taxRateFormat } from '@/utils/taxAmount';

/**
 * Гейтинг percentNDS по usesNDS в динамической форме поставщика (8045).
 * Поля появятся в схеме UpdateSupplierInput после правок Pimcore-админки;
 * до этого весь гейтинг — no-op (guard по наличию полей в fieldComponents).
 */
export const USES_NDS_FIELD = 'usesNDS';
export const PERCENT_NDS_FIELD = 'percentNDS';

/**
 * usesNDS может прийти как boolean (GraphQL Boolean) или строка yes/no (Pimcore select).
 * Редактирование percentNDS разрешено только при явном «да».
 */
export const isNdsEnabled = (value: unknown): boolean => {
  if (value === true) return true;
  if (value === null || value === undefined) return false;
  const normalized = String(value).trim().toLowerCase();
  return normalized === 'yes' || normalized === 'true' || normalized === '1';
};

/**
 * Правило Vuetify для percentNDS: целое число 0–100, пустое значение допустимо.
 * Реюзает taxRateFormat из utils/taxAmount.
 */
export const percentNdsRule = (value: unknown): boolean | string => taxRateFormat(value as string | number) || 'Ставка НДС — целое число от 0 до 100';

/**
 * Значение percentNDS считается заполненным (нужен сброс при usesNDS=no).
 */
export const hasPercentNdsValue = (value: unknown): boolean => value !== null && value !== undefined && String(value).trim() !== '';
